package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/** v2 `model { ... }` 声明。 */
data class ModelAst(
    val params: ParamsAst? = null,
    val state: StateAst? = null,
    val sessionNamespaces: List<NamespacedStateAst> = emptyList(),
    val persistNamespaces: List<NamespacedStateAst> = emptyList(),
    val derived: DerivedAst? = null,
    override val position: SourcePosition,
) : AstNode

/** v2 `params { ... }` 声明。 */
data class ParamsAst(
    val entries: List<ParamEntry>,
    override val position: SourcePosition,
) : AstNode {
    data class ParamEntry(
        val name: String,
        val type: TypeAst,
        val defaultValue: ExprAst?,
        val position: SourcePosition,
    )
}

/** v2 `session namespace { ... }` / `persist namespace { ... }` 声明。 */
data class NamespacedStateAst(
    val namespace: String,
    val state: StateAst,
    val position: SourcePosition,
)
